module.exports = __webpack_public_path__ + "static/illustration-2-440f91449131b1aa92b2c593c86e82be.svg";